module.exports = __webpack_public_path__ + "img/installer-win-07.bcbcf32c.png";